import { defineComponent } from 'vue';

export default defineComponent({
	name: 'EGS_Column',
	inheritAttrs: false,
	props: {
		field: String,
		header: String,
		sortable: Boolean,
		sortField: String,
		selectionMode: String,
		expander: Boolean,
		exportable: { type: Boolean, default: true },
		frozen: Boolean,
		alignFrozen: String,
		headerStyle: [String, Object],
		bodyStyle: [String, Object]
	},
	setup() {
		return () => null;
	}
});
